import React, { useState, useRef, useEffect } from "react";
import CloseButton from "../assets/dashNeedHelpClose.svg";
import MailImg from "../assets/dashboardmailimg.svg";
import { Tab, Tabs } from "@mui/material";
import faqIcon from "../assets/faqIconBgWhite.png";
import AccordionComponent from "../../dashboard/components/AccordionComponent";
import strings from "../../../utils/Strings";

export interface RightModalProps {
  isOpen?: boolean;
  toggleModal?: () => void;
}

export const ContentWrapper = ({
  question,
  children,
  onClose,
}: {
  question: string;
  children: React.ReactNode;
  onClose: () => void;
}) => (
  <div
    style={{
      margin: "20px",
      // border: "1px solid #ddd",
      borderRadius: "40px",
    }}
  >
    {/* Header with Question + Close button */}
    <div
      style={{
        // backgroundColor: "#c3f1ff",
        backgroundColor: "#FFFFFF",
        padding: "20px",

        borderTopLeftRadius: "40px",
        borderTopRightRadius: "40px",
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        cursor: "pointer",
      }}
      onClick={onClose}
    >
      <span
        style={{
          fontSize: "16px",
          fontWeight: 400,
          fontFamily: "Mazzard",
          color: "#242730",
        }}
      >
        {question}
      </span>
      <span style={{ fontWeight: "bold", fontSize: "20px" }}>
        <img src={""} />
      </span>
    </div>

    {/* Content */}
    <div
      style={{
        padding: "20px",
        paddingTop: "0px",
        // backgroundColor: "#c3f1ff",
        backgroundColor: "#FFFFFF",
        borderBottomLeftRadius: "40px",
        borderBottomRightRadius: "40px",
      }}
    >
      {children}
    </div>
  </div>
);

export const QuestionHeader = ({
  text,
  onClick,
}: {
  text: string;
  onClick: () => void;
}) => (
  <h1
    style={{
      fontSize: "16px",
      backgroundColor: "#FFFFFF",
      margin: "20px",
      padding: "15px",
      paddingRight: "20px",
      paddingLeft: "20px",
      borderRadius: "40px",
      cursor: "pointer",
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      fontWeight: 400,
      color: "#242730",
      fontFamily: "Mazzard",
    }}
    onClick={onClick}
  >
    {text}
    <span style={{ fontWeight: "bold", fontSize: "20px" }}>
      <img src={""} />
    </span>
  </h1>
);

const CodeEdgeNeedHelp: React.FC<RightModalProps> = ({
  isOpen,
  toggleModal,
}) => {
  const contentRef = useRef<HTMLDivElement>(null);
  const [isScrolledToTop, setIsScrolledToTop] = useState(true);
  const [isScrolledToBottom, setIsScrolledToBottom] = useState(false);
  const [activeTab, setActiveTab] = useState(0);

  useEffect(() => {
    const handleScroll = () => {
      if (contentRef.current) {
        const { scrollTop, scrollHeight, clientHeight } = contentRef.current;
        const tolerance = 10; // Larger tolerance to handle edge cases

        setIsScrolledToTop(scrollTop <= tolerance);
        setIsScrolledToBottom(
          scrollTop + clientHeight >= scrollHeight - tolerance,
        );
      }
    };
    const refCurrent = contentRef.current;
    if (refCurrent) {
      refCurrent.addEventListener("scroll", handleScroll);
    }

    handleScroll();

    return () => {
      if (refCurrent) {
        refCurrent.removeEventListener("scroll", handleScroll);
      }
    };
  }, [isOpen]);

  const handleScrollDown = () => {
    if (contentRef.current) {
      contentRef.current.scrollBy({ top: 100, behavior: "smooth" });
    }
  };

  const handleScrollUp = () => {
    if (contentRef.current) {
      contentRef.current.scrollBy({ top: -1000, behavior: "smooth" });
    }
  };

  const onTabChange = (index: number) => {
    setActiveTab(index);
  };
  return (
    <>
      {isOpen && (
        <div className="dashboardv2-needhelp-overlay" onClick={toggleModal} />
      )}
      <div
        className={`dashboardv2-needhelp-right-modal ${isOpen ? "open" : ""}`}
      >
        {/* Dashboard Need Help Header */}
        <div className="dashboardv2-needhelp-header">
          <div className="dashboardv2-needhelp-headerrow">
            <img src={faqIcon} alt="contact-button" />
            <h4>Need help?</h4>
          </div>
          <div className="dashboardv2-needhelp-header-end">
            <div className="dashboardv2-needhelp-contact-header">
              <img
                src={MailImg}
                className="dashboardv2-needhelp-contact-image"
                alt="contact-button"
                onClick={() => {
                  window.open(
                    "https://mail.google.com/mail/?view=cm&fs=1&to=support@jozuna.com",
                    "_blank",
                  );
                }}
              />
              <div
                className="dashboardv2-needhelp-contact-text"
                onClick={() => {
                  window.open(
                    "https://mail.google.com/mail/?view=cm&fs=1&to=support@jozuna.com",
                    "_blank",
                  );
                }}
              >
                Get Support
              </div>
            </div>
            <img
              src={CloseButton}
              className="dashboardv2-close"
              onClick={toggleModal}
              alt="close-button"
            />
          </div>
        </div>
        {/* Dashboard Need Help Body Top */}
        <div className="dashboardv2-needhelp-content">
          {/* Need Help Top Content */}
          {/* <div className="dashboardv2-top-header-top-content">
          <div className="dashboardv2-top-header-main-text">
            Welcome to your personalized growth area!
          </div>
          <div className="dashboardv2-top-header-sub-text">
            {" "}
            This dashboard is designed to give you a clear and comprehensive
            view of your learning journey on the Jozuna platform. Below are
            answers to some common questions about what you're seeing.
          </div>
        </div> */}
        </div>
        {/* Need Help Tab bar */}
        {/* <div className="ass-needhelp-tab-container">
          <Tabs
            value={activeTab}
            onChange={(e, newValue) => onTabChange(newValue)}
            sx={{
              "& .MuiTabs-indicator": {
                background: "#054472",
                height: "5px",
                borderRadius: "4px 4px 0px 0px",
                transition: "left 0.3s ease",
              },
              "& .MuiTab-root": {
                marginLeft: "20px",
                fontSize: "18px",
                fontWeight: "400", // Default font weight
                color: "#555", // Default color
                textTransform: "none",
              },
              "& .Mui-selected": {
                fontWeight: "700", // Bold active tab
                color: "#054472", // Active tab color
              },
            }}
          >
            <Tab
              className={`ass-needhelp-tab ${activeTab === 0 ? "selected" : ""}`}
              label={
                <div style={{ display: "flex", alignItems: "center" }}>
                  <span className="ass-needhelp-tab-label"></span>
                </div>
              }
            />
            <Tab
              label={
                <div style={{ display: "flex", alignItems: "center" }}>
                  <span className="ass-needhelp-tab-label">
                    {" "}
                    Engagement Activity{" "}
                  </span>
                </div>
              }
              className={`tab ${activeTab === 1 ? "selected" : ""}`}
            />
            <Tab
              label={
                <div style={{ display: "flex", alignItems: "center" }}>
                  <span className="ass-needhelp-tab-label">
                    {" "}
                    Program Schedule{" "}
                  </span>
                </div>
              }
              className={`ass-needhelp-tab ${activeTab === 2 ? "selected" : ""}`}
            />
            <Tab
              label={
                <div style={{ display: "flex", alignItems: "center" }}>
                  <span className="ass-needhelp-tab-label">
                    {" "}
                    Jozuna Skills Performance{" "}
                  </span>
                </div>
              }
              className={`ass-needhelp-tab ${activeTab === 3 ? "selected" : ""}`}
            />
            <Tab
              label={
                <div style={{ display: "flex", alignItems: "center" }}>
                  <span className="ass-needhelp-tab-label">
                    {" "}
                    Curriculum & Professional Performance{" "}
                  </span>
                </div>
              }
              className={`ass-needhelp-tab ${activeTab === 4 ? "selected" : ""}`}
            />
          </Tabs>
        </div> */}
        {/* Divider */}
        <div
          className="curriculum-needhelp-horizontal-divider"
          style={{
            marginLeft: "15px",
            marginRight: "15px",
            marginBottom: "15px",
          }}
        ></div>

        {/* Overall Progress */}
        {
          <div
            style={{
              padding: "16px",
              gap: "15px",
              display: "flex",
              flexDirection: "column",
            }}
          >
            <AccordionComponent title="Programming languages can I try?">
              <div
                style={{
                  fontFamily: "Mazzard",
                  fontSize: "14px",
                }}
              >
                You can try out programs in Java, Javascript, and Python.{" "}
              </div>
            </AccordionComponent>
            <AccordionComponent title="How do I see “Detailed Analysis”?">
              <div
                style={{
                  fontFamily: "Mazzard",
                  fontSize: "14px",
                }}
              >
                {" "}
                Once you have completed an Industry grade programming
                assessment, detailed analysis appears to you under the
                assessment dashboard.
              </div>
            </AccordionComponent>

            <AccordionComponent title="What is “Code Quality Score”?">
              <div
                style={{
                  fontFamily: "Mazzard",
                  fontSize: "14px",
                }}
              >
                {" "}
                Our AI analyses the submitted program for correctness, adherence
                to best practices, optimization and quality. The detailed
                feedback showcases areas of improvement and approaches to
                optimization.
              </div>
            </AccordionComponent>
          </div>
        }

        {/* Need Help Scroll Button */}
        {/* <div className="dashboard-scroll-buttons">
        <img
          height={"60px"}
          width={"120px"}
          src={isScrolledToBottom ? ScrollUpButton : ScrollDownButton}
          alt={isScrolledToBottom ? "Scroll Up" : "Scroll Down"}
          className="dashboard-scroll-btn"
          onClick={isScrolledToBottom ? handleScrollUp : handleScrollDown}
          style={{ cursor: "pointer" }}
        />
      </div> */}
      </div>
    </>
  );
};

export default CodeEdgeNeedHelp;
